module.exports = "https://web-assets.ifttt.com/packs/media/icons/created-b98bd529.png";